var render = function() {
  var _obj, _obj$1, _obj$2, _obj$3
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "nsHero",
      class: [
        _vm.$style.container,
        ((_obj = {}),
        (_obj[_vm.$style.leftAlign] = _vm.scrimAlign === "left"),
        (_obj[_vm.$style.rightAlign] = _vm.scrimAlign === "right"),
        _obj)
      ]
    },
    [
      _c("div", {
        class: [
          _vm.$style.backgroundImage,
          ((_obj$1 = {}),
          (_obj$1[_vm.$style.fullBleed] = _vm.fullBleed),
          _obj$1)
        ],
        style: _vm.backgroundImageStyle
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            _vm.$style.textbox,
            ((_obj$2 = {}),
            (_obj$2[_vm.$style.dark] = _vm.scrimTextColor === "dark"),
            (_obj$2[_vm.$style.light] = _vm.scrimTextColor === "light"),
            _obj$2)
          ]
        },
        [
          _c(
            "div",
            { class: _vm.$style.scrim, style: _vm.scrimStyle },
            [
              _vm.headlineText
                ? _c("h2", {
                    ref: "header",
                    class: [
                      _vm.$style.header,
                      ((_obj$3 = {}),
                      (_obj$3[_vm.$style.titleLarge] =
                        _vm.headlineFontFamily === "Proxima Nova"),
                      (_obj$3[_vm.$style.titleDecor] =
                        _vm.headlineFontFamily === "Freeland"),
                      _obj$3)
                    ],
                    domProps: { innerHTML: _vm._s(_vm.headlineText) }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.bodyText
                ? _c("p", {
                    class: _vm.$style.bodyText,
                    domProps: { innerHTML: _vm._s(_vm.bodyText) }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.ctaLabel
                ? _c("p", { class: _vm.$style.ctaMobile }, [
                    _vm._v("\n        " + _vm._s(_vm.ctaLabel) + "\n      ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.ctaType === "button" && _vm.ctaLabel
                ? _c(
                    "button",
                    {
                      class: [_vm.$style.ctaButton, _vm.buttonClass],
                      on: { click: _vm.processHeroClick }
                    },
                    [
                      _vm.isVideo
                        ? _c("NsIcon", {
                            class: _vm.$style.videoIcon,
                            attrs: { "icon-name": "icon-play-outline" }
                          })
                        : _vm._e(),
                      _vm._v("\n        " + _vm._s(_vm.ctaLabel) + "\n      ")
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.ctaType === "expressive-link" && _vm.ctaLabel
                ? _c(
                    "NsExpressiveLink",
                    {
                      class: _vm.$style.expressiveLink,
                      attrs: {
                        invert:
                          _vm.scrimTextColor === "light" ||
                          _vm.ctaLinkTheme === "inverted"
                      },
                      on: { click: _vm.processHeroClick }
                    },
                    [_vm._v("\n        " + _vm._s(_vm.ctaLabel) + "\n      ")]
                  )
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", {
        class: _vm.$style.mobileCoverLink,
        on: { click: _vm.processHeroClick }
      }),
      _vm._v(" "),
      _vm.isVideo
        ? _c("NsLightbox", {
            attrs: {
              open: _vm.lightboxOpen,
              "video-src": _vm.ctaUrl,
              "video-src-tags": _vm.ctaVideoSrcTags
            },
            on: { close: _vm.handleCloseLightbox }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }